import React from 'react'
import {FormattedMessage} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {Hotel} from '@findhotel/sapi'
import isChromatic from 'chromatic'
import {getAllFilterKeys} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {useHideAnchorHotel} from 'hooks/useHideAnchorHotel'
import {
  getIsSearchCompleted,
  getIsSearchHasResults,
  getShowHostelsAlert
} from 'modules/sapiSearch/selectors'
import {
  getIsAnchorHotelHidden,
  getIsUserClosedHostelAlert,
  getIsUserInteractedWithFilters
} from 'modules/search/selectors'

import {Alert} from '@vio/atlas/Alert'
import {Box} from '@vio/atlas/helpers/Box'
import OpacityAnimation from '@vio/atlas/helpers/OpacityAnimation'
import {Icon} from '@vio/atlas/Icon'
import {Link} from '@vio/atlas/Link'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page
} from '@vio/core/src/analytics/types/Events'

const allFilterKeys = getAllFilterKeys()
const elementName = 'anchorHotelHiddenAlert'

interface Props {
  hotelId: Hotel['objectID']
}
export const HotelAnchorHiddenAlert = ({hotelId}: Props) => {
  const dispatch = useDispatch()
  const {hotelName} = useHideAnchorHotel(hotelId)
  const {clearFiltersAndApply} = useFiltersForm(allFilterKeys, elementName)

  const isUserClosedHostelAlert = useSelector(getIsUserClosedHostelAlert)
  const showHostelsAlert = useSelector(getShowHostelsAlert)
  const isAnchorHotelHidden = useSelector(getIsAnchorHotelHidden)
  const isAnchorScenario = Boolean(hotelId)
  const isSearchHasResults = useSelector(getIsSearchHasResults)
  const isSearchCompleted = useSelector(getIsSearchCompleted)

  const isUserInteractedWithFilters = useSelector(
    getIsUserInteractedWithFilters
  )
  const handleClearFilters = () => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.AnchorHotelHiddenBannerCta,
        action: Action.Clicked,
        page: Page.Search
      })
    )
    clearFiltersAndApply()
  }

  if (
    !isAnchorScenario ||
    !isAnchorHotelHidden ||
    (!isUserClosedHostelAlert && showHostelsAlert) ||
    (!isSearchHasResults && isSearchCompleted && isUserInteractedWithFilters)
  )
    return null

  return (
    <OpacityAnimation delay={200} duration={0.5} skip={isChromatic()}>
      <Box marginBottom="s600">
        <Alert icon={<Icon name="Information" />}>
          <FormattedMessage
            id="anchorHotelHiddenAlert.message"
            defaultMessage="{hotelName} was hidden because it doesn’t match your filters."
            values={{hotelName}}
          />
          {` `}
          <Link onClick={handleClearFilters}>
            <FormattedMessage
              id="clearFilters"
              defaultMessage="Clear filters"
            />
          </Link>
        </Alert>
      </Box>
    </OpacityAnimation>
  )
}
